import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseUrl';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  tagTypes: [
    "ScriptTypes",
    "OutputTemplates",
    "VmTemplates",
    // Add other tags here as needed
    // "Scripts",
    // "CloudEnvironments",
  ],
});

